import { inr } from "@/lib/format";

const Row = ({ label, value, muted, testId, strong }) => (
  <div className={`flex justify-between gap-4 py-2 text-sm ${muted ? "text-[#6b6b6b]" : "text-[#1A1A1A]"} ${strong ? "font-medium" : ""}`}>
    <span>{label}</span>
    <span data-testid={testId} className="text-right">{value}</span>
  </div>
);

export default function PriceSummary({ lines, nights, offer }) {
  const quote = lines.some((l) => l.price === null);
  const subtotal = lines.reduce((s, l) => s + (l.price || 0) * l.qty * nights, 0);
  const pct = offer?.active && !quote ? offer.percent : 0;
  const discount = Math.round((subtotal * pct) / 100);
  return (
    <div data-testid="price-summary">
      {lines.length === 0 && <p className="text-sm text-[#6b6b6b] py-2">Select at least one room to see the price.</p>}
      {lines.map((l) => (
        <Row key={l.slug} label={`${l.name} × ${l.qty} × ${nights} night${nights > 1 ? "s" : ""}`} value={l.price === null ? "Rate on request" : inr(l.price * l.qty * nights)} testId={`summary-line-${l.slug}`} />
      ))}
      <div className="border-t border-[#E2DCD0] mt-2 pt-2">
        <Row label="GST" value="Included in tariff" muted testId="summary-gst" />
        <Row label="Breakfast" value="Included" muted testId="summary-breakfast" />
        <Row label="Extra bed" value="Complimentary" muted testId="summary-extra-bed" />
        {discount > 0 && <Row label={offer.label || `Offer (${pct}%)`} value={`− ${inr(discount)}`} testId="summary-discount" />}
      </div>
      <div className="border-t border-[#1E3B2E] mt-2 pt-4 flex justify-between items-end">
        <span className="eyebrow text-[#1E3B2E] whitespace-nowrap">{quote ? "Total" : "Total payable"}</span>
        <span className="font-['Cormorant_Garamond'] text-3xl text-[#1E3B2E] whitespace-nowrap" data-testid="summary-total">{quote ? <span className="text-xl">To be confirmed</span> : inr(subtotal - discount)}</span>
      </div>
      {quote && <p className="text-xs text-[#1E3B2E] mt-2" data-testid="summary-quote-note">Your selection includes a room with rate on request. The hotel will confirm the final amount before you pay — no payment is taken now.</p>}
      <p className="text-[11px] text-[#6b6b6b] mt-2">All prices are in INR and inclusive of applicable GST. No hidden charges.</p>
    </div>
  );
}
